{
  "avalancheSize.label": "Tamaño del alud",
  "avalancheSize.small": "pequeño",
  "avalancheSize.medium": "mediano",
  "avalancheSize.large": "grande",
  "avalancheSize.very_large": "muy grande",
  "avalancheSize.extreme": "extremadamente grande",
  "snowpackStability.label": "Estabilidad del manto de nieve",
  "snowpackStability.good": "buena",
  "snowpackStability.fair": "regular",
  "snowpackStability.poor": "pobre",
  "snowpackStability.very_poor": "muy pobre",
  "frequency.label": "Frecuencia",
  "frequency.none": "ninguna",
  "frequency.few": "pocas",
  "frequency.some": "algunas",
  "frequency.many": "muchas",
  "dangerRating.label": "Grados de peligro",
  "dangerRating.missing": "ausente",
  "dangerRating.missing.long": "Ausente",
  "dangerRating.no_snow": "sin nieve",
  "dangerRating.no_snow.long": "Sin nieve",
  "dangerRating.no_rating": "sin grado de peligro",
  "dangerRating.no_rating.long": "Sin grado de peligro",
  "dangerRating.low": "débil",
  "dangerRating.low.long": "Grado de Peligro 1 — Débil",
  "dangerRating.low.speech": "Peligro de aludes débil, por lo que el grado de peligro es uno.",
  "dangerRating.moderate": "limitado",
  "dangerRating.moderate.long": "Grado de Peligro 2 — Limitado",
  "dangerRating.moderate.speech": "Peligro de aludes limitado, por lo que el grado de peligro es dos.",
  "dangerRating.considerable": "notable",
  "dangerRating.considerable.long": "Grado de Peligro 3 — Notable",
  "dangerRating.considerable.speech": "Peligro de aludes notable, por lo que el grado de peligro es tres.",
  "dangerRating.high": "fuerte",
  "dangerRating.high.long": "Grado de Peligro 4 — Fuerte",
  "dangerRating.high.speech": "Peligro de aludes fuerte, por lo que el grado de peligro es cuatro.",
  "dangerRating.very_high": "muy fuerte",
  "dangerRating.very_high.long": "Grado de Peligro 5 — Muy Fuerte",
  "dangerRating.very_high.speech": "Peligro de aludes muy fuerte, por lo que el grado de peligro es cinco.",
  "avalancheType.label": "Tipo de alud",
  "avalancheType.slab": "Alud de placa",
  "avalancheType.loose": "Alud de nieve sin cohesión",
  "avalancheType.glide": "Alud de deslizamiento de nieve",
  "avalancheProblem.label": "Problema de Aludes",
  "avalancheProblem.new_snow": "Nieve reciente",
  "avalancheProblem.wind_slab": "Placa de viento",
  "avalancheProblem.persistent_weak_layers": "Capa débil persistente",
  "avalancheProblem.wet_snow": "Nieve húmeda",
  "avalancheProblem.gliding_snow": "Deslizamiento de nieve",
  "avalancheProblem.favourable_situation": "Situación favorable",
  "avalancheProblem.cornices": "Cornisas",
  "avalancheProblem.no_distinct_avalanche_problem": "Ningún problema de aludes evidente",
  "avalancheProblem.new_snow.speech": "un problema de nieve reciente",
  "avalancheProblem.wind_slab.speech": "un problema de placas de viento",
  "avalancheProblem.persistent_weak_layers.speech": "un problema de capa débil persistente",
  "avalancheProblem.wet_snow.speech": "un poblema de nieve húmeda",
  "avalancheProblem.gliding_snow.speech": "un problema de deslizamiento basal",
  "avalancheProblem.favourable_situation.speech": "una situación favorable",
  "avalancheProblem.cornices.speech": "un problema de cornisas",
  "avalancheProblem.no_distinct_avalanche_problem.speech": "ningún problema de aludes evidente",
  "dangerPattern.label": "Patrones de peligro",
  "dangerPattern.dp1": "pp.1: capas débiles persistentes profundas",
  "dangerPattern.dp2": "pp.2: deslizamientos",
  "dangerPattern.dp3": "pp.3: lluvia",
  "dangerPattern.dp4": "pp.4: frío después de cálido / cálido después de frío",
  "dangerPattern.dp5": "pp.5: nevada después de un largo periodo frío",
  "dangerPattern.dp6": "pp.6: frío, nieve suelta y viento",
  "dangerPattern.dp7": "pp.7: zonas de poca nieve en entornos con mucha nieve",
  "dangerPattern.dp8": "pp.8: escarcha de superfície cubierta de nieve",
  "dangerPattern.dp9": "pp.9: nieve granulada cubierta de nieve",
  "dangerPattern.dp10": "pp.10: escenario de primavera",
  "aspect.N": "Norte",
  "aspect.NE": "Noreste",
  "aspect.E": "Este",
  "aspect.SE": "Sudeste",
  "aspect.S": "Sur",
  "aspect.SW": "Sudoeste",
  "aspect.W": "Oeste",
  "aspect.NW": "Noroeste",
  "tendency.label": "Tendencia",
  "tendency.decreasing": "Tendencia: peligro de aludes en disminución",
  "tendency.steady": "Tendencia: peligro de aludes sin cambios",
  "tendency.increasing": "Tendencia: peligro de aludes en aumento",
  "validTimePeriod.all_day": "día entero",
  "validTimePeriod.all_day.long": "día entero",
  "validTimePeriod.earlier": "AM",
  "validTimePeriod.earlier.long": "al inicio del día",
  "validTimePeriod.later": "PM",
  "validTimePeriod.later.long": "al final del día",
  "elevation.treeline.capitalized": "Límite del bosque",
  "elevation.treeline": "límite del bosque",
  "elevation.all": "Todas las elevaciones",
  "elevation.below": "Por debajo de {0}",
  "elevation.above": "Por encima de {0}",
  "elevation.band": "Entre {0} y {1}",
  "synopsis.label": "Tiempo",
  "snowpack.label": "Manto nivoso",
  "travelAdvisory.label": "Travel Advisory",
  "forecast.label": "Predicción de Aludes"
}
